import { useState, useEffect } from "react";
import { api, formatEuro, formatData } from "@/lib/api";
import { StatoBadge } from "@/components/Badges";
import AssegnoDettaglio from "@/components/AssegnoDettaglio";
import { AlertTriangle, Clock, CalendarDays, CalendarCheck, Ban } from "lucide-react";

const SEZIONI = [
  { key: "scaduti", label: "Scaduti", icon: Ban, color: "border-l-[#B84223]", chip: "bg-[#FBE3DA] text-[#B84223]" },
  { key: "entro_7", label: "Entro 7 giorni", icon: AlertTriangle, color: "border-l-[#D45D3C]", chip: "bg-[#FBE3DA] text-[#B84223]" },
  { key: "entro_15", label: "Entro 15 giorni", icon: Clock, color: "border-l-[#D98A2C]", chip: "bg-[#FBEAD2] text-[#A86616]" },
  { key: "entro_30", label: "Entro 30 giorni", icon: CalendarDays, color: "border-l-[#D98A2C]", chip: "bg-[#FBEAD2] text-[#A86616]" },
  { key: "oltre_30", label: "Oltre 30 giorni", icon: CalendarCheck, color: "border-l-[#4B6B4E]", chip: "bg-[#E8F0E9] text-[#2F5235]" },
];

const Scadenze = () => {
  const [data, setData] = useState({});
  const [sel, setSel] = useState(null);
  const [open, setOpen] = useState(false);

  const carica = () => api.scadenze().then(setData).catch(() => {});
  useEffect(() => { carica(); }, []);

  const apri = (a) => { setSel(a); setOpen(true); };

  const Card = ({ a, chip }) => (
    <div
      data-testid="scadenza-card"
      onClick={() => apri(a)}
      className="bg-white border border-[#E5E2DC] rounded-lg p-4 cursor-pointer hover:shadow-sm hover:-translate-y-0.5 transition-all"
    >
      <div className="flex justify-between items-start">
        <div>
          <p className="font-medium text-sm">{a.banca || "Banca n.d."}</p>
          <p className="text-xs text-[#5C5F58] font-mono-num">N° {a.numero_assegno || "—"}</p>
        </div>
        <StatoBadge stato={a.stato} />
      </div>
      <div className="flex justify-between items-end mt-3">
        <div>
          <p className="font-mono-num font-bold">{formatEuro(a.valore)}</p>
          <p className="text-xs text-[#5C5F58] mt-0.5">Scad. {formatData(a.data_scadenza)}</p>
        </div>
        <span className={`rounded-full px-2.5 py-0.5 text-xs font-semibold ${chip}`}>
          {a.giorni_alla_scadenza < 0
            ? `${Math.abs(a.giorni_alla_scadenza)}g fa`
            : a.giorni_alla_scadenza === 0
            ? "Oggi"
            : `${a.giorni_alla_scadenza}g`}
        </span>
      </div>
    </div>
  );

  return (
    <div className="space-y-8">
      <div>
        <h1 className="font-heading text-3xl md:text-4xl font-bold tracking-tight">Scadenze</h1>
        <p className="text-[#5C5F58] mt-1">Assegni raggruppati per fasce di scadenza</p>
      </div>

      <div className="space-y-6">
        {SEZIONI.map((sez) => {
          const items = data[sez.key] || [];
          return (
            <div key={sez.key} className={`bg-white border border-[#E5E2DC] border-l-4 ${sez.color} rounded-xl shadow-sm`}>
              <div className="flex items-center justify-between px-6 py-4 border-b border-[#F2F0EB]">
                <div className="flex items-center gap-3">
                  <sez.icon className="w-5 h-5 text-[#5C5F58]" strokeWidth={1.8} />
                  <h2 className="font-heading text-lg font-semibold">{sez.label}</h2>
                </div>
                <span className={`rounded-full px-2.5 py-0.5 text-xs font-bold ${sez.chip}`} data-testid={`conteggio-${sez.key}`}>
                  {items.length}
                </span>
              </div>
              <div className="p-6">
                {items.length === 0 ? (
                  <p className="text-sm text-[#5C5F58]">Nessun assegno in questa fascia.</p>
                ) : (
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {items.map((a) => <Card key={a.id} a={a} chip={sez.chip} />)}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      <AssegnoDettaglio
        assegno={sel}
        open={open}
        onOpenChange={setOpen}
        onUpdated={carica}
        onDeleted={carica}
      />
    </div>
  );
};

export default Scadenze;
